"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgeGroups = void 0;
const age_group_1 = require("./age-group");
const types_1 = require("@hoepel.app/types");
class AgeGroups {
    constructor(props) {
        this.props = props;
    }
    get ageGroups() {
        return this.props.ageGroups
            .map((ageGroup) => age_group_1.AgeGroup.fromProps(ageGroup))
            .sort((a, b) => a.name.localeCompare(b.name));
    }
    get names() {
        return new Set(this.ageGroups.map((group) => group.name));
    }
    get namesSorted() {
        return [...this.names].sort();
    }
    get switchOverOn() {
        return this.props.switchOverOn;
    }
    get id() {
        return `${this.tenantId}-agegroups`;
    }
    /** Ages that are not in use yet by any age group */
    get unusedAges() {
        const usedAges = this.usedAges;
        return new Set([...AgeGroups.validAges.values()].filter((age) => !usedAges.has(age)));
    }
    get usedAges() {
        const ages = this.ageGroups.map((group) => group.validForAges);
        return ages.reduce((acc, curr) => new Set([...acc, ...curr]), new Set());
    }
    get tenantId() {
        return this.props.tenantId;
    }
    static fromProps(props) {
        return new AgeGroups(props);
    }
    static create(tenantId, switchOverOn) {
        return this.fromProps({
            tenantId,
            switchOverOn,
            ageGroups: [],
        });
    }
    static createEmpty(tenantId) {
        return this.create(tenantId, 'childs-birthday');
    }
    static get validAges() {
        return new Set([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16]);
    }
    toProps() {
        return {
            tenantId: this.tenantId,
            switchOverOn: this.switchOverOn,
            ageGroups: this.ageGroups.map((group) => group.toProps()),
        };
    }
    withAddedAgeGroup(ageGroup) {
        return AgeGroups.fromProps({
            ...this.toProps(),
            ageGroups: [...this.toProps().ageGroups, ageGroup.toProps()],
        });
    }
    withSwitchOverOn(switchOverOn) {
        return AgeGroups.fromProps({
            ...this.toProps(),
            switchOverOn,
        });
    }
    withAgeGroupRemoved(ageGroupName) {
        return AgeGroups.fromProps({
            ...this.toProps(),
            ageGroups: this.ageGroups
                .filter((group) => group.name !== ageGroupName)
                .map((group) => group.toProps()),
        });
    }
    withAgeAddedToAgeGroup(ageGroupName, age) {
        return AgeGroups.fromProps({
            ...this.toProps(),
            ageGroups: this.ageGroups.map((ageGroup) => {
                if (ageGroup.name !== ageGroupName) {
                    return ageGroup.toProps();
                }
                return ageGroup.withAgeAdded(age).toProps();
            }),
        });
    }
    withAgeRemovedFromAgeGroup(ageGroupName, age) {
        return AgeGroups.fromProps({
            ...this.toProps(),
            ageGroups: this.ageGroups.map((ageGroup) => {
                if (ageGroup.name !== ageGroupName) {
                    return ageGroup.toProps();
                }
                return ageGroup.withAgeRemoved(age).toProps();
            }),
        });
    }
    withAgeGroupRenamed(ageGroupCurrentName, ageGroupNewName) {
        if (this.names.has(ageGroupNewName)) {
            throw new Error('Another age group is using that name already');
        }
        return AgeGroups.fromProps({
            ...this.toProps(),
            ageGroups: this.ageGroups.map((ageGroup) => {
                if (ageGroup.name !== ageGroupCurrentName) {
                    return ageGroup.toProps();
                }
                return ageGroup.withName(ageGroupNewName).toProps();
            }),
        });
    }
    classifyPerson(birthDate, currentDate = types_1.DayDate.today()) {
        return (this.ageGroups.find((ageGroup) => ageGroup.belongsToThisGroup(birthDate, this.switchOverOn, currentDate)) || null);
    }
    mayAddAgeGroup(ageGroup) {
        const overlap = this.ageGroups
            .map((group) => group.agesOverlapWith(ageGroup))
            .reduce((acc, set) => new Set([...acc, ...set]), new Set());
        const nameAlreadyExists = this.names.has(ageGroup.name);
        return overlap.size === 0 && !nameAlreadyExists;
    }
    findAgeGroupWithName(name) {
        return this.ageGroups.find((group) => group.name === name) || null;
    }
}
exports.AgeGroups = AgeGroups;
//# sourceMappingURL=age-groups.js.map